import { IncomeSourceProvider, VerifyMethodType } from "shared/types";
import { capitalize } from "shared/utils";
import { IncomeField } from "./types";

export const BankPayrollTooltip = ({
  provider,
  verifyMethod,
  field
}: {
  provider: IncomeSourceProvider | null;
  verifyMethod: VerifyMethodType;
  field: IncomeField;
}) => {
  if (
    !provider ||
    ![IncomeSourceProvider.Argyle, IncomeSourceProvider.Plaid].includes(
      provider
    )
  )
    return null;

  return (
    <>
      <img
        src={`/assets/${provider}_logo.svg`}
        className="h-6 invert mb-2.5"
        alt={provider + " logo"}
      />
      <p className="text-sm text-white">
        Verified {field} monthly calculation received from
        <br />
        {capitalize(verifyMethod)} Provider: {capitalize(provider)}
      </p>
    </>
  );
};
